import { Mode } from '../../fl-bookmarks';

export interface GetBookmarkPlaylistResponse {
  vid?: string;
  o?: number;
  pid?: string;
  ut?: number;
}

export interface BookmarkResponse {
  itemId: string;
  offset?: number;
  ut: number;
  seasonId?: string;
  episodeId?: string;
  snum?: number;
  epnum?: number;
  cty?: string;
  videoId?: string;
  mode?: Mode;
  pb?: GetBookmarkPlaylistResponse[];
}
export interface BookmarkCount {
  count: number;
}

export enum SortOrder {
  ASC,
  DESC,
}

export enum SortBy {
  TIMESTAMP = 'ut',
}
